import React, { useEffect, useState } from 'react';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import Box from '@mui/material/Box';
import { useDispatch, connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
// import { getRestaurantDetails } from '@utilities/auth';
import ItemCounter from '@app/components/ItemCounter';
import Cart from '@app/components/Cart';
import { addToCart } from '@utilities/cart';
import Loader from '@components/Loader';
import Select from '@components/Select';
import lodash from "lodash";
import Icon from '@mui/material/Icon';
import { IconMap, ImagesGS } from '@src/constants/common';
import SearchInput from '@components/SearchInput';
import { hasPermission } from '@utilities/common';
import './POSPanel.scss';
// import { fuzzySearchFoodItems, SearchResult } from './SearchItem';
import { handleSearchFoodItems } from "./SearchUtils";

const POSPanel = ({ type, cart, tableNumber = "table-1", isClassExtra, products, catOrder, restaurantDetails, roles: _roles, userPermissions, selectedRestId: _selectedRestId }: any) => {
    const [toggle, setToggle] = useState(false);
    const [selectedCat, setSelectedCat] = useState("add-ons");
    // const [products, setProducts]: any = useState({});
    // const [catOrder, setCatOrder] = useState([]);
    // const [restaurantDetails, setRestaurantDetails]: any = useState({});
    const [selectMap, setSelectMap]: any = useState({});
    const dispatch = useDispatch();
    let params = useParams();
    const [query, setQuery] = useState("");
    const [results, setResults] = useState<any>([]);
    const searchFoodFeature = hasPermission(userPermissions, "searchFood", "read");

    const onSearch = (query: string) => {
        const found = handleSearchFoodItems(products, query);
        setResults(found);
    };
    useEffect(() => {
        if (query.trim()) {
            onSearch(query);
        } else {
            setResults(null);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- onSearch uses products; avoid stale closure
    }, [query, products]);

    const handleAddToCart = (item: any, key: any, name: any) => {
        // console.log('selectMap', selectMap, key + '-' + name, selectMap[key + '-' + name]);
        const selVar = selectMap[key + '-' + name] || { value: item.variants[0].cost, label: `₹${item.variants[0].cost} / ${item.variants[0].size}` };
        // console.log('selVar', selVar, item.variants[0]);
        if (!cart[tableNumber] || !cart[tableNumber][key + '-' + name + '-' + selVar.value]?.selected) {
            addToCart({ ...item, category: key, name: name, selectedVariants: selVar, variants: null }, key + '-' + name + '-' + selVar.value, dispatch, tableNumber, params?.restaurantId);
        }
    };

    // useEffect(() => {
    //     if(!localStorage.getItem("RESTAURANTS_DATA")){
    //         getRestaurantDetails(dispatch);
    //     }
    // }, []);

    useEffect(() => {
        // restaurants.filter((res: any) => res.docId === params.restaurantId).forEach((item: any) => {
        // setProducts(item?.menu);
        // setCatOrder(item?.categoryOrder || []);
        // setRestaurantDetails(item);
        // setSelectedCat(item?.categoryOrder?.length && item?.categoryOrder[0] || Object.keys(item?.menu)[0] || "add-ons");
        // });
        setSelectedCat((restaurantDetails?.categoryOrder?.length && restaurantDetails?.categoryOrder[0]) || (restaurantDetails?.menu?.length && Object.keys(restaurantDetails?.menu)[0]) || "add-ons");
    }, [restaurantDetails]);
    // }, [restaurants, params.restaurantId]);

    const handleSelectChange = (val: any, key: any) => {
        setSelectMap({ ...selectMap, [key]: val })
    };

    const handleSelectBlur = (event: any) => {
        event.stopPropagation();
    };

    return (
        <div className={`detailsPageWrap ${type} ${isClassExtra && "extra"}`}>
            <ul className='menuNav'>
                {
                    ((!!catOrder.length && catOrder) || (!!products && Object.keys(products).sort()) || []).map((key: any, _index: any) => (
                        <li key={key} onClick={() => setSelectedCat(key)} className={key === selectedCat ? "selected" : ""}>
                            {/* <RenderDynamicIcon className="iconMenu" name="Fastfood" /> */}
                            <p className="textMenu">&nbsp;{key.split("-").join(" ")}</p>
                            {IconMap[key] && <Icon color="primary" className='menuIconDynamic'>{IconMap[key]}</Icon>}
                        </li>
                    ))
                }
            </ul>
            <div className='menuList'>
                {searchFoodFeature && <SearchInput onSearch={(value: any) => setQuery(value)} delay={300} placeholder="Search food..." />}
                {!!results?.length && searchFoodFeature &&  <Box
                    className='product-item'
                    sx={{
                        display: 'flex',
                        borderBottom: '2px solid var(--primary)',
                        backgroundColor: 'var(--primary-light25)',
                        padding: '0.5rem',
                        marginBottom: '1rem',
                        flexWrap: 'wrap',
                        '& > :not(style)': {
                            m: 1,
                            width: 200,
                            height: 100,
                        },
                    }}
                >
                    {results.map((item: any) => {
                        const selVar = selectMap[item?.category + '-' + item?.itemKey] || { value: item?.item?.variants[0].cost, label: `₹${item?.item?.variants[0].cost} / ${item?.item?.variants[0].size}` };
                        return (
                            <div key={item?.category + '-' + item?.itemKey} className={`card-wrap food-type food-type_${item?.item?.type}`} >
                                <Paper onClick={() => handleAddToCart(item?.item, item?.category, item?.itemKey)} elevation={3}>
                                    <span className='product-item__image'>
                                        <img src={item?.item?.image || ImagesGS.itemPlaceholder} title={item?.itemKey} alt={item?.category} />
                                    </span>
                                    <span className='item-wrap'>
                                        <p className='item__name'>{!!item?.itemKey && item?.itemKey.replaceAll("-", " ")}</p>
                                        {/* <p className='item__price'>{item?.item?.variants[0].cost} / {item?.item?.variants[0].size}</p> */}
                                        <div onClick={(item?.item?.variants.length > 1) ? handleSelectBlur : () => { }}>
                                            <Select
                                                className="selectWrap"
                                                onChange={(val: any) => handleSelectChange(val, item?.category + '-' + item?.itemKey)}
                                                defaultValue={{ value: item?.item?.variants[0].cost, label: `₹${item?.item?.variants[0].cost} / ${item?.item?.variants[0].size}` }}
                                                options={item?.item?.variants.map((val: any) => ({ value: val.cost, label: `₹${val.cost} / ${val.size}` }))}
                                                isDisabled={!(item?.item?.variants.length > 1)}
                                            />
                                        </div>
                                        <ItemCounter tableNumber={tableNumber} keyVal={item?.category + '-' + item?.itemKey + '-' + (selectMap[item?.category + '-' + item?.itemKey] ? selectMap[item?.category + '-' + item?.itemKey]?.value : item?.item?.variants[0].cost)} item={{ ...item?.item, category: item?.category, name: item?.itemKey, selectedVariants: selVar, variants: null }} />
                                    </span>
                                </Paper>
                            </div>
                        );
                    })
                    }
                </Box>}
                {!products && <Loader />}
                <div key={selectedCat}>
                    {/* <h4 className='heading--h4'>
                        &nbsp;{selectedCat.split("-").join(" ")}</h4> */}
                    <Box
                        className='product-item'
                        sx={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            '& > :not(style)': {
                                m: 1,
                                width: 200,
                                height: 100,
                            },
                        }}
                    >
                        {

                            !!products[selectedCat] && lodash.sortBy(Object.entries(products[selectedCat]), [function (o: any) { return o[1].order }]).map(([keyP, catP]: any, _indexP: any) => {
                                // if(!cat.available){
                                //     return null;
                                // }
                                const selVar = selectMap[selectedCat + '-' + keyP] || { value: catP.variants[0].cost, label: `₹${catP.variants[0].cost} / ${catP.variants[0].size}` };
                                return (
                                    <div key={selectedCat + '-' + keyP} className={`card-wrap food-type food-type_${catP.type}`} >
                                        <Paper onClick={() => handleAddToCart(catP, selectedCat, keyP)} elevation={3}>
                                            <span className='product-item__image'>
                                                <img src={catP.image || ImagesGS.itemPlaceholder} title={keyP} alt={selectedCat} />
                                            </span>
                                            <span className='item-wrap'>
                                                <p className='item__name'>{!!keyP && keyP.replaceAll("-", " ")}</p>
                                                {/* <p className='item__price'>{catP.variants[0].cost} / {catP.variants[0].size}</p> */}
                                                <div onClick={(catP.variants.length > 1) ? handleSelectBlur : () => { }}>
                                                    <Select
                                                        className="selectWrap"
                                                        onChange={(val: any) => handleSelectChange(val, selectedCat + '-' + keyP)}
                                                        defaultValue={{ value: catP.variants[0].cost, label: `₹${catP.variants[0].cost} / ${catP.variants[0].size}` }}
                                                        options={catP.variants.map((val: any) => ({ value: val.cost, label: `₹${val.cost} / ${val.size}` }))}
                                                        isDisabled={!(catP.variants.length > 1)}
                                                    />
                                                </div>
                                                <ItemCounter tableNumber={tableNumber} keyVal={selectedCat + '-' + keyP + '-' + (selectMap[selectedCat + '-' + keyP] ? selectMap[selectedCat + '-' + keyP]?.value : catP.variants[0].cost)} item={{ ...catP, category: selectedCat, name: keyP, selectedVariants: selVar, variants: null }} />
                                            </span>
                                        </Paper>
                                    </div>
                                )
                            })
                        }
                    </Box>
                </div>
            </div>
            <div className='cart-wrap'>
                <IconButton className='mob-cart-btn' onClick={() => setToggle(!toggle)} color="primary" aria-label="add to shopping cart">
                    <AddShoppingCartIcon />
                </IconButton>
                {!!restaurantDetails?.docId
                    && <Cart type={type} tableNumber={tableNumber} toggle={toggle} restaurant={{ ...restaurantDetails, menu: null }} />}
            </div>
        </div>
    );
}

const mapStateToProps = (state: any) => {
    const { common, cart, user } = state;

    return {
        restaurantDetails: common?.selectedRestaurant || {},
        products: common?.selectedRestaurant?.menu || {},
        catOrder: common?.selectedRestaurant?.categoryOrder || {},
        cart: (cart && cart[common?.selectedRestaurant?.docId]) || {},
        isClassExtra: Object.entries(common?.selectedRestaurant?.tabs || {}).length > 1,
        restaurants: common?.restaurants,
        selectedRestId: common?.selectedRestaurant?.docId || "",
        roles: user?.user?.roles || {},
        userPermissions: user?.user?.roles ? {...common?.globalConfig?.permissions, ...(user?.user?.roles[common?.selectedRestaurant?.docId]?.permissions)} : {}
    }
}

export default connect(mapStateToProps)(POSPanel)
